import { Component, OnInit, ChangeDetectorRef, ViewChild, TemplateRef } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators, NgForm } from '@angular/forms';
import { AuthenticationService, Item, TestData, Category, Complexity, Type, Style } from '../services/authentication.service';
import { Router } from '@angular/router';
import { MediaMatcher } from '@angular/cdk/layout';
import { TestSchedulerService } from '../services/test_scheduler.service';
import { QuestionSetService, QuestionSet } from '../services/questionset.service';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { MatTableDataSource } from '@angular/material/table';
import {MatSortModule, MatSort} from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import Swal from 'sweetalert2';



@Component({
  templateUrl: './questionset.component.html',
  styleUrls: ['./questionset.component.scss'],

})
export class QuestionSetComponent {
  selectedCategory;
 displayedColumns: string[] = ['Question_Set_Name','Unique_or_NonUnique','No_of_Candidates','actions'];
  dataSource = new MatTableDataSource<any>([]);
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild("viewquestionset") modalquestionset: TemplateRef<any>;
  selectedCategoryindex: string;
  newAttribute: any = {};
  Question_Category: any;
  resultRes: boolean;
  details: boolean;
  Category;
  tableIndex: number = 0;
  Type;
  pageSize = 5;
  Complexity;
  complexityId: string;
  fname;
  lname;
  user;
  result:any=[]
  userAdmin: boolean;
  userSuperAdmin: boolean;
  pageIndex: number = 0;
  userTestScheduler: boolean;
  userTestTaker: boolean;
  overall: boolean;
  questionset: boolean;
  scheduletest: boolean;
  evaluate: boolean;
  mobileQuery: MediaQueryList;
  modalRef: any;
  question_set_arr: any = [];
  private _mobileQueryListener: () => void;
  category: Category = {
    category_name: ''
  };
  type: Type = {
    cate_id: '',
    subcategory_id: '',
    style_id:''
  };

  test: TestData = {
    id: '',
    FirstName: '',
    LastName: '',
    Email: '',
    Phone: '',
    Type: ''
  };

  style: Style = {
    cate_id: '',
    subcategory_id: ''
  }

  question_set: QuestionSet = {
    Question_Set_Name: ''
  }
  question_set_config: any;
  questionset_config: any =[];
  userEvaluator: boolean;

  constructor(private fb: FormBuilder, private auth: AuthenticationService, private router: Router, private qs: QuestionSetService,
    private modal: NgbModal, private testschedulerservice: TestSchedulerService, changeDetectorRef: ChangeDetectorRef, media: MediaMatcher) {
    this.getAccess();
    // this.simpletest();
    this.Questionset();
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }
  // ngAfterViewInit() {
   
  //   this.dataSource.sort = this.sort;
  // }

  onPageSizeChange(value: string) {
    this.pageSize = +value; // Convert the string to a number
  }
  
  
  getAccess(){
    this.user = sessionStorage.getItem('user');
    this.fname = sessionStorage.getItem('fname');

    this.lname = sessionStorage.getItem('lname');


    if (this.user === '1') {
      this.userAdmin = true;
      this.userTestScheduler = false;
      this.userEvaluator = false;
    } else if (this.user === '2') {
      this.userEvaluator = true;
      this.userAdmin = false;
      this.userTestScheduler = false;
    } else if (this.user === '3') {
      this.userTestScheduler = true;
      this.userAdmin = false;
      this.userEvaluator = false;  
    }
  }

  //   simpletest() {
  //     console.log(this.test,"test")
  //     this.testschedulerservice.test_scheduler(this.test).subscribe(
  //       (data) => {

  //         this.user = sessionStorage.getItem('user');
  //         this.fname = sessionStorage.getItem('fname');

  //         this.lname = sessionStorage.getItem('lname');


  //           return this.result;
  //       },
  //       err => {
  //         console.error(err);
  //       }
  //     );
  // }

  Questionset() {
    this.qs.questionset(this.question_set).subscribe(
      (data) => {

        this.result = data.results;
        this.dataSource = new MatTableDataSource<any>(this.result);
        console.log("this.dataSource",this.dataSource);
        this.dataSource.sort = this.sort;
        
        this.dataSource.paginator = this.paginator;
        console.log("resultuuuuuu",this.result)

      },
      err => {
        console.error(err);
      }
    );
  }

  OnAddQuestionSet() {

    this.router.navigateByUrl('/designTest');
  }
  
  clone(row: any) {
    
  this.router.navigate(['/clonequestion_set', row]);
}


  // edit(set) {
  //
  //
  //   this.router.navigate(['/edit_question_set', set.Id]);
  // }

  onPageChange(event: any): void {
    this.pageIndex = event.pageIndex; 
    console.log("pageIndex",this.pageIndex);
  }

  delete(set,index: number) {
console.log("this.set",set);
console.log("i",index);
index= index + this.pageIndex * 5;
console.log("Page Index",this.pageIndex);
    Swal.fire({
      title: 'Are you sure want to delete?',
      text: 'You will not be able to recover later!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    }).then((result) => {
      if (result.isConfirmed) {
        this.qs.delete(set).subscribe(
          (data) => {
            if (data.code === 400) {
              Swal.fire({
                title: 'Alert',
                text: data.failed,
                icon: 'warning',
                showCancelButton: false,
                confirmButtonText: 'OK'
              }).then((resultRes) => {
                if (resultRes.isConfirmed) {
                  
                }
              })
            } else if (data.code === 200) {
              
              Swal.fire({
                title: 'Success',
                text: data.success,
                icon: 'success',
                showCancelButton: false,
                confirmButtonText: 'OK'
              }).then((resultRes) => {
               
              this.result.splice(index,1)
              this.dataSource = new MatTableDataSource(this.result);
              this.dataSource.paginator = this.paginator;
              })
    
            }
    
            return;
          });
      }
    })
   
  }

  get_question_set_config(set){

    this.qs.get_set_configuration_details(set).subscribe(
      (data) =>{
        
        console.log("data",data.set_config)
        this.question_set_config = data.set_config;
        //
        this.questionset_config = [];
        for(var i=0;i<this.question_set_config.length;i++){
          this.questionset_config.push(this.question_set_config[i][0])
        }


      }
    )
  }

  view(set) {
  console.log("set",set);
    this.qs.get_set_details(set).subscribe(
      (data) => {
        this.question_set_arr = data.results
        console.log("question_set_arr",this.question_set_arr)

        if (this.question_set_arr[0].question_pattern == 'U') {
          this.question_set_arr[0].question_pattern = 'Unique'
        }
        else if (this.question_set_arr[0].question_pattern == 'N') {
          this.question_set_arr[0].question_pattern = 'Non-Unique'
        }
        else {
          this.question_set_arr[0].question_pattern = 'Random'
        }
        this.get_question_set_config(set)
      }
    )
    let ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false
    };
    this.modalRef = this.modal.open(this.modalquestionset, ngbModalOptions)
  }

}
